import { DefineRemoteComponent } from '@enbw/frontend-utils/module-federation/react'
import { FC } from 'react'
import { Outlet } from 'react-router'
import { MsalProvider } from '@azure/msal-react'
import '@enbw/ui-react/enbw-enterprise.css'
import '@/styles/global.scss'
import pkg from '@root/package.json'
import { QueryClientProvider } from '@/contexts/QueryClientProvider'
import { AuthContextProvider } from '@/application/auth/contexts'
import { msalInstance } from '@/application/auth/config/msalInstance'

export const App: FC = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <DefineRemoteComponent name={pkg.name} version={pkg.version}>
        <AuthContextProvider>
          <QueryClientProvider>
            <Outlet />
          </QueryClientProvider>
        </AuthContextProvider>
      </DefineRemoteComponent>
    </MsalProvider>
  )
}

export default App
